import intlTelInput from "./intlTelInput.directive";

const intlTelInputModule = angular
  .module("app.directives.intlTelInput", [])
  .directive("intlTelInput", intlTelInput);

export default intlTelInputModule;



// WEBPACK FOOTER //
// ./src/directives/intlTelInput/intlTelInput.module.js